import { hexToRGBA } from '../../common';
import { lightTheme } from './themes';

export const shadowColor = (isDark: boolean) => {
    const palette = lightTheme.uiFabricTheme.palette;
    const baseBlack = palette.black;

    return isDark ? hexToRGBA(baseBlack, 0.87) : hexToRGBA(baseBlack, 0.13);
};
